export class DemoStrings {
    public static BminingSaaS = "Bmining SaaS"
}